import ApiService from './api';

const FeedbackService = {
  getFeedback: async function (id) {
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/selectfeedback?username=${id}`;
    try {
      const res = await ApiService.get(query);
      if (res && res.status) {
        console.log('-- get feedback data ok --');
        return res.data;
      }
      console.warn('!! get feedback data invalid');
      return false;
    } catch (error) {
      console.warn('!! get feedback data error ', error);
      return false;
    }
  },

  getFeedbackScore: async function (id){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/selectstars?username=${id}`;
    try {
      const res = await ApiService.get(query);
      if (res && res.status) {
        console.log('-- get stars data ok --');
        return res.data;
      }
      console.warn('!! get stars data invalid');
      return false;
    } catch (error) {
      console.warn('!! get stars data error ', error);
      return false;
    }
  }
}

export default FeedbackService;
